// import React from 'react';
// import logo from './logo.svg';
// import './App.css';
// import HomePage from './pages/home';

// function App() {
//   return (
//     <div >
//     <HomePage />
//     </div>
//   );
// }

// export default App;


import React from "react";
import { Routes, Route } from "react-router-dom";

import HomePage from "./pages/home";
import About from "./pages/aboutUs";
import Navbar from "./components/navBar";
import Footer from "./components/footer";
import ShilajitProductPage from "./components/products/shilajaitproduct";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/energy-vitality/shilajit" element={<ShilajitProductPage />} />
         <Route path="/products/sexual-wellness/shilajit" element={<ShilajitProductPage />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;